import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { __API_URL__ } from "../SERVER_URL";

const fetchPatientAppDocuments = async ({ trialId, patientId }) => {
  const token = localStorage.getItem("token");

  const res = await axios.get(`${__API_URL__}/api/patient/patient/app_documents/`, {
    params: {
      trial_id: trialId,
      patient_id: patientId,
    },
    headers: {
      Authorization: `Token ${token}`,
    },
  });

  return res.data || [];
};

const useGetPatientAppDocuments = ({ trialId, patientId, enabled = true }) => {
  return useQuery({
    queryKey: ["patient-app-documents", trialId, patientId],
    queryFn: () => fetchPatientAppDocuments({ trialId, patientId }),
    enabled: enabled && Boolean(trialId) && Boolean(patientId),
  });
};

export default useGetPatientAppDocuments;
